export default __webpack_public_path__ + "static/media/Order_Step_1.5899ef8e.svg";